import React, { useEffect, useState } from "react";
import $ from "jquery";
import { useParams } from "react-router-dom";

const Language = ({ freshlang }) => {
  const [langSelect, setLangSelect] = useState("");

  const { lang } = useParams();

  useEffect(() => {
    if (lang) {
      setLangSelect(lang);
      localStorage.setItem("language", lang);
    } else {
      const savedLang = localStorage.getItem("language");
      if (savedLang) {
        setLangSelect(savedLang);
      } else {
        localStorage.setItem("language", "en");
        setLangSelect("en")
      }
    }
  }, []);

  const langChange = (e) => {
    var queryParams = new URLSearchParams(window.location.search);
    queryParams.set("lang", e.target.value);
    window.history.replaceState(null, null, "?" + queryParams.toString());
    setLangSelect(e.target.value);
    freshlang(e.target.value);
    localStorage.setItem("language", e.target.value);
  };

  return (
    <>
      <div className="langselecttop">
        <select
          className="lang_selected"
          onChange={(e) => langChange(e)}
          value={langSelect}
        >
          <option value="en">English</option>
          <option value="gu">Gujarati</option>
          <option value="hi">Hindi</option>
          <option value="be">Bengali</option>
          <option value="ka">Kannada</option>
          <option value="ma">Malayalam</option>
          <option value="mar">Marathi</option>
          <option value="od">Odia</option>
          <option value="ta">Tamil</option>
          <option value="te">Telugu</option>
          <option value="pu">Punjabi</option>
          <option value="asm">Assamese</option>
        </select>
        <img
          // src="/assets/images/arrowdownblack.svg"
          src="/assets/images/arrowwhite.svg"
          className="arrowblack"
          alt="Arrow Down"
        />
      </div>
    </>
  );
};
export default Language;
